import { useMutation, useQuery } from 'react-query';
import {
  getGroupGiftOrders,
  downloadGroupGiftOrdersExcel,
  saveGroupGiftTrackingNumber,
  getGroupGiftOrderDetail,
  updateGroupGiftOrder
} from 'apis';
import { IGroupGiftOrder, IGroupGiftOrdersParams, IGroupGiftOrdersResponse } from 'interfaces/bizGift';

// 단체선물대장 공급처 주문 목록 조회
export const useGroupGiftOrders = (params: IGroupGiftOrdersParams, enabled = true) => {
  return useQuery<IGroupGiftOrdersResponse>(['getGroupGiftOrders', params], () => getGroupGiftOrders(params), { enabled });
};

// 단체선물대장 공급처 주문내역 엑셀 다운로드
export const useDownloadGroupGiftOrdersExcel = () => {
  return useMutation(['downloadGroupGiftOrdersExcel'], (params: unknown) => downloadGroupGiftOrdersExcel(params));
};

// 단체선물대장 공급처 주문 송장번호 등록
export const useSaveGroupGiftTrackingNumber = () => {
  return useMutation(['saveGroupGiftTrackingNumber'], (saveData: unknown) => saveGroupGiftTrackingNumber(saveData));
};

// 단체선물대장 공급처 주문 단건 상세
export const useGroupGiftOrderDetail = (groupGiftOrderIdx?: number | string) => {
  return useQuery<IGroupGiftOrder>(
    ['getGroupGiftOrderDetail', groupGiftOrderIdx],
    () => getGroupGiftOrderDetail(groupGiftOrderIdx as number | string),
    { enabled: !!groupGiftOrderIdx }
  );
};

// 단체선물대장 공급처 주문 단건 수정
export const useUpdateGroupGiftOrder = () => {
  return useMutation(
    ['updateGroupGiftOrder'],
    ({ groupGiftOrderIdx, saveData }: { groupGiftOrderIdx: number | string; saveData: unknown }) =>
      updateGroupGiftOrder(groupGiftOrderIdx, saveData)
  );
};
